import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-cy"]
const _hoisted_2 = {
  key: 1,
  class: "custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
}

import { checklistRequestedStatusId, CHECKLISTSTATUS } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentChecklistStatusTag',
  props: {
  checklistStatus: {
    type: String as PropType<string>,
    default: "",
  },
  checklistStatusId: {
    type: String as PropType<string>,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: true,
  },
  className: {
    type: String as PropType<string>,
    default: "",
    required: false,
  },
  isArchived: {
    type: Boolean,
    default: false,
    required: false,
  },
  checklistRequestedId: {
    type: String as PropType<string>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const statusAssessment = {};

statusAssessment[checklistRequestedStatusId.inProgress] = {
  label: getComponentUiText(
    "app-component-assessments-checklist-requested-status-inprogress-1",
  ),
  className: "inProgress",
};
statusAssessment[checklistRequestedStatusId.completed] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-requested-status-completed-1",
  ),
  className: "complete",
};
statusAssessment[checklistRequestedStatusId.created] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-requested-status-created-1",
  ),
  className: "created",
};
statusAssessment[checklistRequestedStatusId.waiting] = {
  label: getComponentUiText(
    "app-component-assessments-checklist-requested-status-waiting-1",
  ),
  className: "inProgress",
};
statusAssessment[checklistRequestedStatusId.submitted] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-requested-status-submitted-1",
  ),
  className: "submitted",
};
statusAssessment[CHECKLISTSTATUS.PAUS] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-requested-status-paused-1",
  ),
  className: "onHold",
};
statusAssessment[CHECKLISTSTATUS.NOT_STARTED] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-2",
  ),
  className: "notStarted",
};

return (_ctx: any,_cache: any) => {
  return (!__props.isLoading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["tw-px-[5px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded", `${
      !__props.isArchived
        ? statusAssessment[props.checklistStatusId].className
        : 'deleted'
    }`])
      }, [
        _createElementVNode("span", {
          class: "class",
          "data-cy": `${
        props.checklistRequestedId
          ? 'current-assessment-status-' + props.checklistRequestedId
          : 'assessment-status'
      }`
        }, _toDisplayString(!__props.isArchived
          ? statusAssessment[props.checklistStatusId].label
          : _unref(getComponentUiText)(
              "app-component-assessments-checklists-requested-status-deleted-1",
            )), 9, _hoisted_1)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_2))
}
}

})